import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { useAccountCreationContext } from '@/components/signup/account-creation/hooks/account-creation-context';
import { Button } from '@/libraries/design/components/button/src/button';

export const InlineSubmit = ({ showArrow = false }: { showArrow?: boolean } = {}) => {
	const intl = useIntl();
	const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
		useAccountCreationContext();

	const buttonText = intl.formatMessage({
		id: 'BxpUiSignup.SignupForm.submit',
		defaultMessage: 'Sign up',
	});

	const ariaLabel = intl.formatMessage({
		id: 'WacSignupForm.socialSignUpButtonSignUpWithEmail',
		defaultMessage: 'Sign up with email',
	});

	return (
		<Button
			css={buttonCss}
			type="submit"
			disabled={isSubmitting || (hasSubmitted && !formError)}
			onClick={onClickSubmitButton}
			aria-label={ariaLabel}
			data-testid="embedded-signup-submit"
			dataEventProps={{
				'data-product-key': 'uniform',
				'data-event': 'clicked',
				'data-event-component': 'button',
				'data-event-container': 'signup',
				'data-label': buttonText,
				'data-label-english': 'Sign up',
			}}
		>
			{buttonText}
			{showArrow ? (
				<span css={arrowCss} aria-hidden="true">
					<ArrowRightIcon label="" />
				</span>
			) : null}
		</Button>
	);
};

const buttonCss = css({
	alignItems: 'center',
	boxSizing: 'border-box',
	display: 'flex',
	fontFamily: 'inherit',
	fontSize: '18px',
	fontWeight: 400,
	gap: token('space.100'),
	height: '48px',
	justifyContent: 'center',
	minWidth: 'auto',
	whiteSpace: 'nowrap',
	width: 'fit-content',
	[media.above.sm]: {
		margin: '-1px -1px -1px 0',
	},
	[media.below.sm]: {
		width: '100%',
		maxWidth: '100%',
	},
});

const arrowCss = css({
	display: 'inline-flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	['svg']: {
		height: '16px',
		width: '16px',
	},
});
